import {deserialize, inheritSerialization, serialize} from "cerialize";
import BaseEntity from "./BaseEntity";

@inheritSerialization(BaseEntity)
export default class BulkPengajianRequest extends BaseEntity {

    @serialize
    @deserialize
    public from_pengajian: string = "";

    @serialize
    @deserialize
    public to_pengajian: string = "";

    public file: any = null;

    public static OnSerialized(instance: BulkPengajianRequest, json: any): void {
        if (parseInt(json.id) === 0) {
            delete json.id;
        }
    }

}
